/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { Checkbox, Classes } from '@blueprintjs/core';
import smallCross from './small-cross.svg';
import { Colors } from 'styles/variables';

/**
 *
 * @param {boolean} isSelected = false,
 * @param {boolean} isExcluded = false,
 * @param {boolean} isAncestorSelected = false,
 * @param {boolean} isAncestorExcluded = false,
 * @param {boolean} hasSelectedChild = false,
 * @param {boolean} hasExcludedChild = false,
 */
export const FacetCheckbox = ({
	isSelected = false,
	isExcluded = false,
	isAncestorSelected = false,
	isAncestorExcluded = false,
	hasSelectedChild = false,
	hasExcludedChild = false,
	...props
}) => {
	// STATELESS //

	const indeterminate = (!isSelected && !isExcluded) && (hasSelectedChild || hasExcludedChild);
	const inferred = !indeterminate && (isAncestorSelected && !isExcluded) || isAncestorExcluded;
	const selected = isSelected || isAncestorSelected;
	const excluded = isExcluded || isAncestorExcluded || (!hasSelectedChild && hasExcludedChild);

	return (
		<CustomCheckbox
			checked={selected}
			excluded={excluded}
			indeterminate={indeterminate}
			inferred={inferred}
			{...props} // disabled={disabled}
		/>
	);
};

// this exists to strip off the excluded and inferred props so react wont error
const CheckboxProxy = ({ excluded, inferred, ...props }) => (<Checkbox {...props} />)

const CustomCheckbox = styled(CheckboxProxy)`
	margin: 0;
	.${Classes.CONTROL_INDICATOR} {
		${p => { if (p.excluded) return excludedStyle; }}
		${p => { if (p.excluded && !p.disabled) return excludedInteractiveStyle; }}
		${p => { if (p.excluded && !p.inferred && !p.indeterminate) return excludedIconStyle; }}
		${p => { if (p.inferred) return inferredStyle; }}
		${p => { if (p.indeterminate) return indeterminateStyle; }}
	}
`;

const inferredStyle = css`
	opacity: 0.5;
	&::before{ // icon
		background-image: unset !important;
	}
`;

const excludedStyle = css`
	background-image: unset;
	background-color: ${Colors.GRAY3} !important;
`;

const excludedInteractiveStyle = css`
	&:hover{
		background-color: ${Colors.GRAY2} !important;
	}
	&:active{
		background-color: ${Colors.GRAY1} !important;
	}
`;

const excludedIconStyle = css`
	&::before{ // icon
		background-image: url("${smallCross}") !important;
	}
`;

const indeterminateStyle = css`
	opacity: 0.5;
`;
